<script lang="ts">
	import { PUBLIC_STRAPI_MEDIA } from '$env/static/public'
	import { is_set_array, is_set_object } from '$lib/js/helpers'
	import { t } from 'svelte-i18n-lingui'
	import type { BlogPost } from '$lib/js/strapi/types'
	import { getContextScope } from '$lib/js/helpers/i18n'

	export let info: BlogPost

	const scope = getContextScope()

	let categories = info.blog_categories
	let img = is_set_object(info.thumbnail) ? info.thumbnail.url : info.hero_section.bg_img.url
</script>


<a href="/{scope}/blog/{info.page_slug}" class="card">
	<div class="card__inner">
		<div class="card__img">
			<div class="card__img-wrapper">
				<img
					src="{PUBLIC_STRAPI_MEDIA}{img}"
					height=180
					width=320
					title="{info.hero_section.page_title}"
					alt="{info.hero_section.page_title}"
				/>
			</div>

			{#if is_set_array(categories)}
				<a
					href="/{scope}/blog/c/{categories[0].name.toLowerCase()}"
					class="category u-btn"
				>{categories[0].name}</a>
			{/if}
		</div>

		<div class="card__content">
			<h3>{info.page_title}</h3>
			<a href="/{scope}/blog/{info.page_slug}" class="link u-btn u-btn--web ripple">{$t`More info`}</a>
		</div>
	</div>
</a>


<style lang="scss">
  .card {
    &__img {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      &-wrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }

      img {
        display: flex;
        width: 100%;
        height: 180px;
        object-fit: cover;
        transition: all linear 0.125s;

        &:hover {
          @media (min-width: 769px) {
            transform: scale(1.1);
          }
        }
      }

      a.category {
        position: relative;
        padding: 0 10px;
        font-weight: 700;
        text-transform: uppercase;
        margin: -15px 20px 20px;
        font-size: 12px;

        @media (min-width: 769px) {
          font-size: 14px;
        }

        &:hover {
          background: var(--main);
          color: white;

          @media (min-width: 769px) {
            transform: scale(1.1);
          }
        }
      }
    }

    &__content {
      h3 {
        font-size: 16px;
        margin-bottom: 22px;
        line-height: 1.3;
        transition: all linear 0.125s;

        @media (min-width: 769px) {
          font-size: 22px;
        }

        &:hover {
          @media (min-width: 769px) {
            color: var(--main);
          }
        }
      }

      .link {
        @media (max-width: 768px) {
          padding: 4px 20px;
        }
      }
    }
  }
</style>
